<template>
    <modal
        :show="flagShow"
        :title="title"
        size="small"
        :needFooter="false"
        :centered="true"
        class="modal-export-layer"
        @close="onClose"
    >
        <form class="export-layer-form"
              autocomplete="off"
              @submit.prevent=""
        >
            <div class="row">
                <div class="col-12">
                    <MaterialSelect
                        :disabled="disabled || loading"
                        class="city-form-group city-bg"
                        id="input-format"
                        name="format"
                        label="label"
                        :filterable="true"
                        :options="formatsList"
                        v-model="form.format"
                        v-validate="'required'"
                        :inputClasses="[{'is-invalid': fnHasError('format')}]"
                        :error="fnFirstError('format')"
                    >
                        File Format
                    </MaterialSelect>
                </div>
            </div>
        </form>
    </modal>
</template>

<script>
import GlobalMixin from '@/app/shared/mixins/global';
import LayerDownloadMixin from '../LayerDownloadMixin';

export default {
    name: "LayerDownloadComponent",
    mixins: [
        GlobalMixin,
        LayerDownloadMixin,
    ],
    components: {
        Modal: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
    },
    props: {
        title: {
            type: String,
            default: 'Export Data',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        url: {
            type: String,
            default: null
        },
        layer: {
            type: Object,
            default: () => {},
        },
        service: {
            type: String,
            default: 'wfs',
        },
        formats: {
            type: Array,
            default: () => [
                {name: 'application/json', label: 'GeoJSON', type: 'vector', validServices: ['wps']},
                {name: 'application/arcgrid', label: 'ArcGrid', type: 'raster', validServices: ['wps']},
                {name: 'image/tiff', label: 'TIFF', type: 'raster', validServices: ['wps']},
                {name: 'image/png', label: 'PNG', type: 'raster', validServices: ['wps']},
                {name: 'image/jpeg', label: 'JPEG', type: 'raster', validServices: ['wps']},
                {name: 'application/wfs-collection-1.0', label: 'wfs-collection-1.0', type: 'vector', validServices: ['wps']},
                {name: 'application/wfs-collection-1.1', label: 'wfs-collection-1.1', type: 'vector', validServices: ['wps']},
                {name: 'application/zip', label: 'Shapefile', type: 'vector', validServices: ['wps']},
                {name: 'text/csv', label: 'CSV', type: 'vector', validServices: ['wps']}
            ],
        },
        wfsFormats: {
            type: Array,
            default: () => [],
        },
        srsList: {
            type: Array,
            default: () =>[
                {name: "native", label: "Native"},
                {name: "EPSG:4326", label: "WGS84"}
            ],
        },
        downloadOptions: {
            type: Object,
            default: () => {},
        },
    },
    data () {
        return {
            flagShow: false,
            loading: false,
            formatsLoading: false,
            form: {
                format: null,
            }
        }
    },
    mounted () {

    },
    computed: {
        validWFSFormats(){
            return this.findValidFormats('wfs');
        },
        wfsFormatsList() {
            return this.validWFSFormats.length > 0 ? this.validWFSFormats.filter(f => this.wfsFormats.find(wfsF => wfsF.name.toLowerCase() === f.name.toLowerCase())) : this.wfsFormats;
        },
        formatsList() {
            this.service === 'wfs' ? this.wfsFormatsList : [];
        },
    },
    methods: {
        showModal: function(data) {
            this.flagShow=true;
            // console.log('url:', this.url);
        },
        closeModal() {
            this.flagShow = false;
            this.$emit('close');
        },
        onClose() {
            this.closeModal();
        },
        findValidFormats(fmt) {
            // console.log('fmt:', fmt, this.layer);
            return this.formats.filter(({validServices, type = 'vector'}) => {
                    return (!validServices || validServices.findIndex(x => x === fmt) > -1) &&
                        (type === 'vector' && this.layer.url || type === 'raster' && !this.layer.url)
                });
        },
        // onFormatOptionsFetch(url) {
        //     this.loading = true;

        //     this.loading = false;
        // }
    },
    watch: {
        flagShow: {
            immediate: false,
            handler(value, oldValue){
                if(value){
                    this.onFormatOptionsFetch(this.layer);
                }
            },
        },
    }
};

</script>

<style lang="scss" scoped>

</style>